import Action from '../../Action'
import './KpiFormModal.css';
import { useState ,useEffect} from 'react';
import LoadSimple from '../../LoadSimple';
import { useFetch } from '../../../hooks/useFetch';
import SelectorAdmin from '../../SelectorAdmin';
import SelectorIcons from '../../SelectorIcons';
import { capitalizeFirstLetter } from '../../../utils/utils';
import { lang } from '../../generales/traduction';
const ModalCreateKpi =({buscar_cis,handleShowPopup,setSearchTerm,languaje,mode,user,dataUsers,devices,server,setRegisterIsValid,groupSelected,setData,loading,setLoading,setError,setEditActive,editActive,closCreateCisModal})=>{
    const obtenerFechaActualLocal = () => {
        const ahora = new Date();
        const anio = ahora.getFullYear();
        const mes = String(ahora.getMonth() + 1).padStart(2, '0'); // El mes se cuenta desde 0
        const dia = String(ahora.getDate()).padStart(2, '0');
        const horas = String(ahora.getHours()).padStart(2, '0');
        const minutos = String(ahora.getMinutes()).padStart(2, '0');
      
        return `${anio}-${mes}-${dia}T${horas}:${minutos}`;
      };
    const [loadingM,setLoadingM]=useState(false);
    const [IpValid,setIpValid]=useState(true)
    const [matchPassword,setMatchPassword]=useState(false)
    const [disabled,setDisabled]=useState(true)
    const [host,sethost]=useState([])

    const typeOperations=[
      {
        id:1,
        name:'Aritmetica'
      },
      {
        id:2,
        name:'ComparacionSencilla'
      },
      {
        id:3,
        name:'Ventana'
      }
    ]

    function getIdByName(name) {
      const operation = typeOperations.find(op => op.name === name);
      return operation ? operation.id : 0;
    }
    const [ManttoData,setManttoData]=useState({
        
          kpi_name: (editActive)?groupSelected.kpi_name:"",
          metric_id: (editActive)?groupSelected.metric_id:0,
          operation_type: (editActive)?groupSelected.operation_type:"",
          arithmetic_value: (editActive)?groupSelected.arithmetic_value:null,
          arithmetic_operator: (editActive)?groupSelected.arithmetic_operator:null,
          comparison_operator: (editActive)?groupSelected.comparison_operator:null,
          comparison_value: (editActive)?groupSelected.comparison_value:null,
          then_value: (editActive)?groupSelected.then_value:null,
          else_value: (editActive)?groupSelected.else_value:null,
          window_min_value: (editActive)?groupSelected.window_min_value:null,
          window_max_value: (editActive)?groupSelected.window_max_value:null,
          window_then_value: (editActive)?groupSelected.window_then_value:null,
          window_else_value: (editActive)?groupSelected.window_else_value:null
        })
    useEffect(()=>{
        if(ManttoData.kpi_name=="" || ManttoData.metric_id==0 || ManttoData.operation_type=="" ){
          setDisabled(true)
          
        }else{
            if(ManttoData.operation_type=="Aritmetica" && (ManttoData.arithmetic_value==null || ManttoData.arithmetic_operator==null) ){
              setDisabled(true)
            }else
            if(ManttoData.operation_type=="ComparacionSencilla" && (ManttoData.comparison_operator==null || ManttoData.comparison_value==null || ManttoData.then_value==null || ManttoData.else_value==null) ){
              setDisabled(true)
            }else
            if(ManttoData.operation_type=="Ventana" && (ManttoData.window_min_value==null || ManttoData.window_max_value==null || ManttoData.window_then_value==null || ManttoData.window_else_value==null) ){
              setDisabled(true)
            }else{
              setDisabled(false)
            }
        }
    },[ManttoData])
    const reqField=()=>{
        return(
          <p className='reqField-gs'>
            *
          </p>
        )
      }
    const [hostName,setHostName]=useState("")
    const [hostLocation,setHostLocation]=useState("")
    const [hostActivate,setHostActivate]=useState(0)


    // const tec_list=useFetch('cassia/ci_elements/technologies','','','GET',server)
    const [msgError,setMsgError]=useState("")
    const [listSearchIP,setListSearchIP]=useState(false)
    const dataMetric=useFetch('cassia/device_metrics','','','GET',server)



    const handleChange=(e)=>{
        const {name,value}=e.target
        if(e.target.name==="criticality"){
            setManttoData((prevState)=>{
                return {
                    ...prevState,
                    [name]:value===""?0:(parseInt(value))
                }
                
            })
        }  else if(e.target.name==="status"){
            setManttoData((prevState)=>{
                return {
                    ...prevState,
                    [name]:(value=="Inactivo")?"Activo":"Inactivo"
                }
                
            })
        }else{
            setManttoData((prevState)=>{
                return {
                    ...prevState,
                    [name]:value
                }
                
            })
        }



        if(e.target.name==="ip"){
            if(value==""){
                setHostLocation("")
                setHostActivate(0)
                setIpValid(true)
                sethost([])
                setHostName("")
                setHostLocation("")
            }else{
                setIpValid(validateIp(value))
            }
           
           
          }
    }

    //     useEffect(()=>{

    //       if( ManttoData.trigger_id==0 || ManttoData.name==""  || ManttoData.description=="" ||
    //          ManttoData.event_message==""  || ManttoData.severity_default_id==0
    //       ){
    //           console.log('disabled')
    //           setDisabled(true)
    //       }else{
    //           console.log('no disabled')
    //           setDisabled(false)
    //       }
    // },[ManttoData])


    const Registrar=()=>{
        let method='POST'
        let url_add=''
        if(editActive){
            method='PUT'
            url_add=groupSelected.id
        }

        let  body ={}



        setLoading(true)
        const fetchDataPost = async () => {
          
       try {
           // console.log(localStorage.getItem('access_token'))
           const response = await fetch(server.url+'/api/v1/cassia/kpis/'+url_add, {
             method: method,  
             headers: {
                "Accept": "application/json",
               // 'Content-Type': 'application/json',
               'Content-Type': 'application/json',
                 Authorization: `Bearer ${localStorage.getItem('access_token')}`,
               },
             body: JSON.stringify(ManttoData),
           });
           if (response.ok) {
             
             const data1 = await response.json();
             setLoading(false)
             // Manejo de la respuesta
             setData(data1)
             buscar_cis()
             handleShowPopup(capitalizeFirstLetter(lang[languaje]['completado']),capitalizeFirstLetter(((editActive)?lang[languaje]['regEditCorr']:lang[languaje]['regGenCorr'])),'', true)
             // console.log(data1);
             closCreateCisModal()
           setRegisterIsValid(true)
           
           const timer = setTimeout(() => {
             setRegisterIsValid(false)
             setEditActive(false)
             closCreateCisModal()
           }, 3000);
         
           } else {
             const data1 = await response.json();
             handleShowPopup('Error!!!',capitalizeFirstLetter(lang[languaje]['regNoGenCorr']),data1.detail, false)
             throw new Error('Error en la solicitud');
           }
       } catch (error) {
              setHostName("")
              setManttoData({type_id:0,name:""})
              
          setLoading(false)
            // Manejo de errores
            setError(error)
            closCreateCisModal()
            setRegisterIsValid(true)
          //   handleShowPopup('Error!!!',capitalizeFirstLetter(lang[languaje]['regNoGenCorr']),capitalizeFirstLetter(lang[languaje]['reportError']), false)
            const timer = setTimeout(() => {
              setRegisterIsValid(false)
              setEditActive(false)
              closCreateCisModal()
            }, 3000);
            console.error(error);
          }
        };

        fetchDataPost();
    }

    const buscar_host=(ip)=>{
        setLoadingM(true)
        const fetchDataPost = async () => {
          
       try {
           const response = await fetch(server.url+'/api/v1/cassia/ci_elements/search_host/'+ip, {
               method: 'GET',  
               headers: {
                 'Content-Type': 'application/json',
                 'accept': 'application/json',
                 'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
               },
             });
           //   console.log(response)
           if (response.ok) {
               const data1 = await response.json();
               setLoadingM(false)
               if(data1.data.length==0){
                   sethost([])
               setHostName("")
               setHostLocation("")
               setHostActivate(0)
                   setMsgError("La IP no existe o no esta dada de alta")
                   setIpValid(false)
               }else{
                   setIpValid(true)

               }
               sethost(data1.data)
               // setDisabled(true)
           } else {
               const data1 = await response.json();
               throw new Error('Error en la solicitud');
           }
       } catch (error) {
            console.error(error);
          }
        };

        fetchDataPost();
    }
    const changeOption=(option,index)=>{
        
        
        let attr=''
        if(option.filter=='Metric'){
          attr='metric_id'
          setManttoData((prevState)=>{
            return {
                ...prevState,
                [attr]:option.value===""?0:(parseInt(option.value))
            }
            
        })
        }else if(option.filter=='Estados'){
          attr='operation_type'
          setManttoData((prevState)=>{
            return {
                ...prevState,
                [attr]:option.label
            }
            
        })

        if(option.label=="Aritmetica"){
          setManttoData((prevState)=>{
            return {
                ...prevState,
                ['arithmetic_operator']:"+"
            }
            
        })
          setManttoData((prevState)=>{
            return {
                ...prevState,
                ["window_min_value"]:null,
                ["window_max_value"]:null,
                ["window_then_value"]:null,
                ["window_else_value"]:null,
                ["comparison_operator"]:null,
                ["comparison_value"]:null,
                ["then_value"]:null,
                ["else_value"]:null,
            }
            
        })
        }else if(option.label=="ComparacionSencilla"){
          setManttoData((prevState)=>{
            return {
                ...prevState,
                ['comparison_operator']:">"
            }
            
        })
          setManttoData((prevState)=>{
            return {
                ...prevState,
                ["window_min_value"]:null,
                ["window_max_value"]:null,
                ["window_then_value"]:null,
                ["window_else_value"]:null,
                ["arithmetic_value"]:null,
                ["arithmetic_operator"]:null,
            }
            
        })
        }else  if(option.label=="ventana"){
          setManttoData((prevState)=>{
            return {
                ...prevState,
                ["arithmetic_value"]:null,
                ["arithmetic_operator"]:null,
                ["comparison_operator"]:null,
                ["comparison_value"]:null,
                ["then_value"]:null,
                ["else_value"]:null,
            }
            
        })
        }
        }

       
        // setManttoRelation(option.value)
            
    }

    const [fecha, setDate] = useState('2023-09-28')
    const validateIp= (ip) => {
        const ipRegex = /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
        let result = ipRegex.test(ip);
        if(result){
            buscar_host(ip)
        }else{
            setHostLocation("")
            setMsgError("Direccion ip no valida")
            sethost([])
                setHostName("")
                setHostLocation("")
                setHostActivate(0)
        }
        return result;
    };
    const [resultList,setResultList]=useState([])


    //   console.log(resultList)

    const closeListSearch=()=>{
        setListSearchIP(false)
    }
    const handleKeyPress = (e) => {
      // Permitir solo números, teclas de control y el punto decimal
      const charCode = e.charCode;
      if (
        (charCode >= 48 && charCode <= 57) || // Números 0-9
        charCode === 46 || // Punto decimal
        charCode === 8 || // Retroceso
        charCode === 37 || // Flecha izquierda
        charCode === 39 ||// Flecha derecha
        charCode === 45 //  negativo
      ) {
        return;
      } else {
        e.preventDefault();
      }
    };
    const handlePaste = (e) => {
      const paste = (e.clipboardData || window.clipboardData).getData('text');
      if (!/^-?\d*\.?\d*$/.test(paste)) {
        e.preventDefault();
      }
    };

    const {
      kpi_name,
      metric_id,
      operation_type,
      arithmetic_value,
      arithmetic_operator,
      comparison_operator,
      comparison_value,
      then_value,
      else_value,
      window_min_value,
      window_max_value,
      window_then_value,
      window_else_value
    }=ManttoData;
    return(
        <div className="modal-GS-content">
            <div className='card-modal-gs modal-verificate'>
                <div className='head-card-modal-gs'>
                    <div className='title-head-card-modal-gs'>
                        {((editActive)?lang[languaje]['editar'].toUpperCase():lang[languaje]['crear'].toUpperCase())+' KPI'}
                    </div>
                </div>
                <div className='content-card-modal-gs' style={{overflowY: 'scroll',scrollbarWidth: 'thin'}}>
                
                                    <div className="form-GS-box"> 
                                    <div className="user-box-GS"  style={{height:'15%'}}>
                                    <input required name="kpi_name"  type="text" value={kpi_name}
                                    onChange={handleChange}  />
                                        <label className='label-GS  '>{capitalizeFirstLetter(lang[languaje]['nombre'])}{(kpi_name=="")?reqField():''}</label>
                                        
                                    </div>
                                    <div className="user-box-GS "  style={{height:'15%'}}>
                                        {
                                            (dataMetric.loading)?<p style={{color:'var(--txt-color)'}}> {capitalizeFirstLetter(lang[languaje]['CargandoDatos'])} . . .</p>:
                                            <SelectorAdmin placeholder={'Seleccionar nivel...'} opGeneral={true} txtOpGen={''}  opt_de={(metric_id==null)?0:metric_id} origen={'Admin'} data={dataMetric.data.data}   loading={dataMetric.loading}  titulo='Metric' selectFunction={changeOption} index={0}></SelectorAdmin>
                                        }
                                        <label className='label-GS'>{capitalizeFirstLetter(lang[languaje]['metrica'])}{(metric_id==0)?reqField():''}</label>   
                                    </div>
                                    <div className="user-box-GS "  style={{height:'15%'}}>
                                        {
                                            <SelectorAdmin placeholder={'Seleccionar nivel...'} opGeneral={true} txtOpGen={''}  opt_de={getIdByName(operation_type)} origen={'Admin'} data={typeOperations}   loading={false}  titulo='Estados' selectFunction={changeOption} index={0}></SelectorAdmin>
                                        }
                                        <label className='label-GS'>{capitalizeFirstLetter(lang[languaje]['tipoOperacion'])}{(operation_type=="")?reqField():''}</label>   
                                    </div>
                                   
                                    
                                    <div className="user-box-GS "  style={{height:'30%'}}>
                                    {operation_type === 'Aritmetica' && (
                        <div className="formula formkpi">
                            <span>KPI = </span>
                            <span className="metric-name">{'Métrica'}</span>
                            <select
                                className="operator"
                                value={arithmetic_operator}
                                onChange={(e) => setManttoData((prevState)=>{
                                  return {
                                      ...prevState,
                                      ['arithmetic_operator']:e.target.value
                                  }
                                  
                              })}
                            >
                                <option value="+">+</option>
                                <option value="-">-</option>
                                <option value="*">×</option>
                                <option value="/">÷</option>
                            </select>
                            <input
                                type="number"
                                className="value-input"
                                value={arithmetic_value}
                                onChange={(e) => setManttoData((prevState)=>{
                                  return {
                                      ...prevState,
                                      ['arithmetic_value']:parseInt(e.target.value)
                                  }
                                  
                              })}
                                placeholder="Valor"
                            />
                        </div>
                    )}   
                     {operation_type === 'ComparacionSencilla' && (
                        <div className="formula formkpi">
                            <span>Si </span>
                            <span className="metric-name">{ 'Métrica'}</span>
                            <select
                                className="operator"
                                value={comparison_operator}
                                onChange={(e) => setManttoData((prevState)=>{
                                  return {
                                      ...prevState,
                                      ['comparison_operator']:e.target.value
                                  }
                                  
                              })}
                            >
                                <option value=">">mayor a</option>
                                <option value="<">menor a</option>
                                <option value="=">igual a</option>
                            </select>
                            <input
                                type="number"
                                className="value-input"
                                value={comparison_value}
                                onChange={(e) => setManttoData((prevState)=>{
                                  return {
                                      ...prevState,
                                      ['comparison_value']:parseInt(e.target.value)
                                  }
                                  
                              })}
                                placeholder="Valor"
                            />
                            <span> entonces KPI = </span>
                            <input
                                type="number"
                                className="value-input"
                                value={then_value}
                                onChange={(e) => setManttoData((prevState)=>{
                                  return {
                                      ...prevState,
                                      ['then_value']:parseInt(e.target.value)
                                  }
                                  
                              })}
                                placeholder="Valor KPI (si es verdadero)"
                            />
                            <span> de lo contrario KPI = </span>
                            <input
                                type="number"
                                className="value-input"
                                value={else_value}
                                onChange={(e) => setManttoData((prevState)=>{
                                  return {
                                      ...prevState,
                                      ['else_value']:parseInt(e.target.value)
                                  }
                                  
                              })}
                                placeholder="Valor KPI (si es falso)"
                            />
                        </div>
                    )}
                    {operation_type === 'Ventana' && (
                        <div className="formula formkpi">
                            <span>Si </span>
                            <span className="metric-name">{ 'Métrica'}</span>
                            <span> está entre </span>
                            <input
                                type="number"
                                className="value-input"
                                value={window_min_value}
                                onChange={(e) => setManttoData((prevState)=>{
                                  return {
                                      ...prevState,
                                      ['window_min_value']:parseInt(e.target.value)
                                  }
                                  
                              })}
                                placeholder="Mínimo"
                            />
                            <span> y </span>
                            <input
                                type="number"
                                className="value-input"
                                value={window_max_value}
                                onChange={(e) => setManttoData((prevState)=>{
                                  return {
                                      ...prevState,
                                      ['window_max_value']:parseInt(e.target.value)
                                  }
                                  
                              })}
                                placeholder="Máximo"
                            />
                            <span> entonces KPI = </span>
                            <input
                                type="number"
                                className="value-input"
                                value={window_then_value}
                                onChange={(e) => setManttoData((prevState)=>{
                                  return {
                                      ...prevState,
                                      ['window_then_value']:parseInt(e.target.value)
                                  }
                                  
                              })}
                                placeholder="Valor KPI (si es verdadero)"
                            />
                            <span> de lo contrario KPI = </span>
                            <input
                                type="number"
                                className="value-input"
                                value={window_else_value}
                                onChange={(e) => setManttoData((prevState)=>{
                                  return {
                                      ...prevState,
                                      ['window_else_value']:parseInt(e.target.value)
                                  }
                                  
                              })}
                                placeholder="Valor KPI (si es falso)"
                            />
                        </div>
                    )}

                                        {/* **************************************** */}
                                    </div>
                                    
                                   
                                   
                                
                                   
                                    
                                    
                                    <div className="user-box-GS" style={{height:'15%'}}>
                                        {
                                            (loading)?<LoadSimple></LoadSimple>
                                            :
                                            <>
                                            <Action disabled={false} origen='Cancelar' titulo={capitalizeFirstLetter(lang[languaje]['cancelar'])}  action={closCreateCisModal}/>
                                            <Action disabled={disabled} origen='Azul' titulo={capitalizeFirstLetter(lang[languaje]['guardar'])}  action={Registrar}/>
                                            </>
                                            // <Action disabled={disabled} origen='Login' titulo='Guardar'  action={Registrar}/>
                                        }
                                            
                                    {
                                        // (registerIsValid && data.message!=="User deleted successfully")?<span className='form-msg-ok'>Usuario registrado correctamente</span>:''
                                    }
                                        
                                    </div>
                                </div>
                </div>
                </div>
        </div>
    )
}

export default ModalCreateKpi